// Thin client for the MCP HTTP surface — wraps fetch and posts the
// LS-SPEC-26 {args: ...} envelope shape. Used by the new consumer
// surfaces (Manage / Settings / Emergency) to call lifestyle-aide
// and lifestyle-bff directly.

import { useAuth } from "./auth";

// Base URLs come from window.* (set by the edge inline script) or
// fall back to the standard SPEC-29 ports.
function aideBase(): string {
  return (
    (typeof window !== "undefined" && (window as any).LIFESTYLE_AIDE_BASE) ||
    "/api/aide"
  );
}

function bffBase(): string {
  return (
    (typeof window !== "undefined" && (window as any).LIFESTYLE_BFF_BASE) ||
    "/api/bff"
  );
}

export interface MCPCallOptions {
  service?: "aide" | "bff";
  signal?: AbortSignal;
}

export async function mcpCall<T = unknown>(
  tool: string,
  args: Record<string, unknown>,
  opts: MCPCallOptions = {},
): Promise<T> {
  const base = opts.service === "bff" ? bffBase() : aideBase();
  const url = `${base}/mcp/${tool}`;
  const init: RequestInit = {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ args }),
  };
  if (opts.signal) {
    init.signal = opts.signal;
  }
  const res = await fetch(url, init);
  if (!res.ok) {
    let detail = "";
    try {
      const body = await res.json();
      detail = body?.detail || JSON.stringify(body);
    } catch {
      detail = await res.text();
    }
    throw new Error(`${tool} → HTTP ${res.status}: ${detail}`);
  }
  return res.json();
}

export function consumerIdOrThrow(): string {
  const id = useAuth.getState().consumerId;
  if (!id) throw new Error("not authenticated");
  return id;
}
